module.exports = __webpack_public_path__ + "static/media/3.31d132b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/accessoires/3.png
// module id = 1136
// module chunks = 0